var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/react-chartjs-2/~/lodash/_Symbol.js
// module id = 165
// module chunks = 0